import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import type { ShipEngine } from '../ShipEngine'
import GraphQLJSON from 'graphql-type-json'
import type { InputDocument } from '../../repository'

@InputType()
export class UpdateShipEngineArgs extends ActionArgs {
  @Field(() => String)
  label_id: string

  @Field(() => GraphQLJSON)
  input: InputDocument<ShipEngine>
}

export interface IUpdateShipEngine extends IAction<void, UpdateShipEngineArgs> {}
